module.exports = __webpack_public_path__ + "static/atlaskit-page-spacing-a387ac734ebad38b056ae9554542e67f.png";